import React, { Component } from "react";
import { BASE_URL } from "../common/common";

const API_URL = BASE_URL;

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      showPassword: false,
      loading: false,
      errorMessage: "",
    };
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value, errorMessage: "" });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { username, password } = this.state;

    if (!username.trim()) return this.setState({ errorMessage: "Username is required." });
    if (!password.trim()) return this.setState({ errorMessage: "Password is required." });

    this.setState({ loading: true, errorMessage: "" });

    try {
      const res = await fetch(`${API_URL}/api/login/adminLogin`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });
      const json = await res.json();

      // ✅ Only login if API returns status: true
      if (json.status) {
        // Save user info from API response
        localStorage.setItem("adminToken", json.data?.login_id || "logged_in");
        localStorage.setItem("adminUser", json.data?.username || username);
        // Notify parent — triggers redirect to dashboard
        this.props.onLogin();
      } else {
        // ✅ Show API error message if login fails
        this.setState({
          loading: false,
          errorMessage: json.message || "Invalid username or password.",
        });
      }
    } catch (err) {
      this.setState({
        loading: false,
        errorMessage: "Cannot connect to server. Please try again.",
      });
    }
  };

  render() {
    const { username, password, showPassword, loading, errorMessage } = this.state;

    return (
      <div style={s.page}>
        <div style={s.card}>

          {/* Brand */}
          <div style={s.brand}>
            <div className="sidebar-logo">
              {/* Line 71 in Login.js — change className */}
              <img src="/tnalogo/tnalogo.png" alt="TNA Logo" className="logo-image-dark" />
            </div>
          </div>

          <h2 style={s.heading}>Welcome Back</h2>
          <p style={s.subheading}>Sign in to your admin account</p>

          {/* Error Message */}
          {errorMessage && <div style={s.errorBox}>{errorMessage}</div>}

          {/* Form */}
          <form onSubmit={this.handleSubmit}>

            {/* Username */}
            <div className="rsp-form-group" style={s.formGroup}>
              <label style={s.label}>Username</label>
              <input
                className="rsp-input" style={s.input}
                type="text"
                name="username"
                value={username}
                placeholder="Enter your username"
                onChange={this.handleChange}
                autoComplete="username"
              />
            </div>

            {/* Password */}
            <div className="rsp-form-group" style={s.formGroup}>
              <label style={s.label}>Password</label>
              <div style={s.passwordRow}>
                <input
                  style={{ ...s.input, flex: 1, borderRight: "none", borderRadius: "8px 0 0 8px" }}
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={password}
                  placeholder="Enter your password"
                  onChange={this.handleChange}
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  style={s.eyeBtn}
                  onClick={() => this.setState((prev) => ({ showPassword: !prev.showPassword }))}
                >
                  {showPassword ? "Hide" : "Show"}
                </button>
              </div>
            </div>

            {/* Submit */}
            <button
              type="submit"
              style={{ ...s.submitBtn, opacity: loading ? 0.7 : 1 }}
              disabled={loading}
            >
              {loading ? "Signing in..." : "Sign In"}
            </button>

          </form>

          <p style={s.footer}>TNA Events & Sports Pvt. Ltd.</p>
        </div>
      </div>
    );
  }
}

const s = {
  page: { minHeight: "100vh", background: "#f0f2f5", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px", fontFamily: "Arial, sans-serif" },
  card: { background: "white", borderRadius: "14px", padding: "40px 36px", width: "100%", maxWidth: "400px", border: "1px solid #e8e8e8", boxShadow: "0 4px 20px rgba(0,0,0,0.08)" },
  brand: { textAlign: "center", marginBottom: "28px" },
  logo: { width: "56px", height: "56px", background: "#1a1a2e", color: "#e8a020", borderRadius: "12px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "16px", fontWeight: "800", margin: "0 auto 12px", letterSpacing: "1px" },
  brandName: { fontSize: "22px", fontWeight: "700", color: "#e8a020", letterSpacing: "1px", margin: 0 },
  brandSub: { fontSize: "12px", color: "#aaa", marginTop: "4px" },
  heading: { fontSize: "20px", color: "#1a1a2e", fontWeight: "600", margin: "0 0 4px" },
  subheading: { fontSize: "13px", color: "#888", marginBottom: "24px" },
  errorBox: { background: "#ffebee", color: "#c62828", border: "1px solid #ffcdd2", borderRadius: "8px", padding: "10px 14px", marginBottom: "18px", fontSize: "13px" },
  formGroup: { marginBottom: "18px" },
  label: { display: "block", fontSize: "13px", color: "#555", fontWeight: "600", marginBottom: "6px" },
  input: { width: "100%", padding: "11px 14px", border: "1px solid #ddd", borderRadius: "8px", fontSize: "14px", outline: "none", fontFamily: "Arial, sans-serif", boxSizing: "border-box" },
  passwordRow: { display: "flex", alignItems: "stretch" },
  eyeBtn: { padding: "0 14px", background: "#f0f2f5", border: "1px solid #ddd", borderLeft: "none", borderRadius: "0 8px 8px 0", fontSize: "12px", color: "#555", cursor: "pointer", fontWeight: "600", whiteSpace: "nowrap" },
  submitBtn: { width: "100%", padding: "13px", background: "#e8a020", color: "white", border: "none", borderRadius: "8px", fontSize: "15px", fontWeight: "700", cursor: "pointer", marginTop: "8px", letterSpacing: "0.5px" },
  footer: { textAlign: "center", fontSize: "11px", color: "#bbb", marginTop: "28px", marginBottom: 0 },
};

export default Login;